import { defineTour } from '@lopettia/simul';

/**
 * Customer success — active customers + the playbook catalogue.
 * Mirrors docs/manuals/09-customer-success.md.
 */
export const customerSuccessTour = defineTour({
  name: 'Customer success rhythm',
  description:
    'Active customer list, account health, and the playbook catalogue that '
    + 'drives every renewal / expansion motion.',
  steps: [
    {
      id: 'cs-active',
      kind: 'navigate',
      target: '[data-tour-id="nav-customers"]',
      toUrl: '/customers',
      prelude: { goto: '/dashboard' },
      message:
        '**Customers** is your post-sale book of business — health, NPS, and '
        + 'next renewal date for every account.',
      advanceOn: 'navigate',
    },
    {
      id: 'cs-playbooks',
      kind: 'navigate',
      target: '[data-tour-id="nav-playbooks"]',
      toUrl: '/admin/playbooks',
      message:
        '**Playbooks** are the templated motions (onboarding, expansion, '
        + 'churn save) you trigger off health signals.',
      advanceOn: 'navigate',
    },
  ],
});

export default customerSuccessTour;
